import { useContext } from 'react';
import { AppContext } from "../context";
import { safeGet } from '../utils';

export default function useUnit (): string {
    const { user } = useContext(AppContext);
    return safeGet(user, 's_unit', '');
}